
















































import "@/assets/css/split.css";
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import CreateMenu from "./createmenu.vue";
import EditMenu from "./editmenu.vue";
import MenuButton from "./menubutton.vue";
import "@/assets/css/table.css";
class PageMenuRequest extends PageRequest {
  keyword: string;
  parentId: number;
  isEnable: number;
  menuType: number;
}

@Component({
  components: { CreateMenu, EditMenu, MenuButton },
})
export default class Menu extends AbpBase {
  edit() {
    this.editModalShow = true;
  }

  pagerequest: PageMenuRequest = new PageMenuRequest();
  creationTime: Date[] = [];
  createModalShow: boolean = false;
  editModalShow: boolean = false;
  menuButtonModalShow: boolean = false;
  treedata: [] = [];
  itemId: string = "0";
  menuId: number = 0;
  splitnum: number = 0.15;
  height: number = 300; //表格高度

  get list() {
    return this.$store.state.menu.list;
  }
  get loading() {
    return this.$store.state.menu.loading;
  }
  async itemtree() {
    await this.$store
      .dispatch("menu/getFirstNodeSelectTree")
      .then((val) => {
        this.treedata = val;
      })
      .catch((err) => {
        //return null;
      });
  }
  create() {
    this.createModalShow = true;
  }
  pageChange(page: number) {
    this.$store.commit("menu/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("menu/setPageSize", pagesize);
    this.getpage();
  }
  getItemId() {
    let item = (this.$refs.tree as any).getSelectedNodes();
    if (item.length > 0) {
      this.pagerequest.parentId = item[0].id;
    }
    this.$store.commit("menu/setCurrentPage", 1);
    this.getpage();
  }
  getSearch() {
    this.$store.commit("menu/setCurrentPage", 1);
    this.getpage();
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    await this.$store.dispatch({
      type: "menu/getAll",
      data: this.pagerequest,
    });
  }
  //按钮管理
  async addbutton() {
    if (this.menuId == 0) {
      this.$Modal.info({
        title: this.L("Tips"),
        content: this.L("NotMenuCnaNotButton"),
      });
      return;
    }
    this.menuButtonModalShow = true;
  }
  get pageSize() {
    return this.$store.state.menu.pageSize;
  }
  get totalCount() {
    return this.$store.state.menu.totalCount;
  }
  get currentPage() {
    return this.$store.state.menu.currentPage;
  }
  columns = [
    {
      type: "index",
      width: 80,
      align: "left",
      title: this.L("IndexNo"),
      fixed: "left",
    },
    {
      title: this.L("MenuTag"),
      key: "tagName",
      width: 230,
      tree: true,
      fixed: "left",
    },
    {
      title: this.L("Name"),
      key: "displayName",
      width: 130,
      fixed: "left",
    },
    {
      title: this.L("Category"),
      key: "menuType",
      width: 130,
      render: (h: any, params: any) => {
        let str = this.L("Unknown");
        let id = params.row.menuType;
        if (id == 1) {
          str = this.L("ParentMenu");
        } else if (id == 2) {
          str = this.L("ParentGroup");
        } else if (id == 3) {
          str = this.L("Menu");
        } else if (id == 4) {
          str = this.L("Button")
        }
        return h("span", str);
      },
    },
    {
      title: this.L("Path"),
      key: "path",
      width: 180,
    },
    {
      title: this.L("Icon"),
      key: "icon",
      width: 180,
    },
    {
      title: this.L("ComponentUrl"),
      key: "componentUrl",
      width: 180,
    },
    {
      title: this.L("RedirectUrl"),
      key: "redirectUrl",
      width: 180,
    },
    {
      title: this.L("LanguageTag"),
      key: "languageTag",
      width: 180,
    },
    {
      title: this.L("Action"),
      key: "action",
      width: 180,
    },
    {
      title: this.L("SortName"),
      key: "sortCode",
      width: 130,
    },
    {
      title: this.L("IsEnable"),
      width: 130,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.isEnable == 1 ? this.L("Actived") : this.L("NoActive")
        );
      },
    },
    {
      title: this.L("Description"),
      key: "remark",
      width: 180,
    },
    {
      title: this.L("Actions"),
      key: "Actions",
      width: 150,
      fixed: "right",
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                  this.$store.commit("menu/edit", params.row);
                  this.edit();
                },
              },
            },
            this.L("Edit")
          ),
          h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
              },
              on: {
                click: async () => {
                  this.$Modal.confirm({
                    title: this.L("Tips"),
                    content: this.L("DeleteConfirm"),
                    okText: this.L("Yes"),
                    cancelText: this.L("No"),
                    onOk: async () => {
                      await this.$store.dispatch({
                        type: "menu/delete",
                        data: params.row,
                      });
                      await this.getpage();
                    },
                  });
                },
              },
            },
            this.L("Delete")
          ),
        ]);
      },
    },
  ];
  //选中
  handleRowChange(currentRow, oldCurrentRow) {
    if (currentRow.menuType == 3) {
      this.menuId = currentRow.id;
    } else {
      this.menuId = 0;
    }
  }
  async created() {
    this.getpage();
    this.itemtree();
  }
  mounted() {
    if (window.innerHeight > 800) {
      this.height = window.innerHeight - 380;
    } else {
      this.height = window.innerHeight - 420;
    }
  }
}
